import React from 'react'

export const Footer = () => {
  return (
    <footer >
      <div  className='foot'>
        <div className='x'>
          <p> Contáctese con Signore: </p>
          <p> gabrielabrahamx@gmail.com </p>
          
        </div>
        <p className='yo'> Redes del desarrollador Front-end  </p> 
        
        <div className='yox1'>
            <p><a href='https://www.linkedin.com/in/facundo-betancur-33659a124/' target='_blank'  rel='noreferrer'> LinkedIn</a></p>
            <p> <a href='https://github.com/RedLineFB'  target='_blank'  rel='noreferrer'>GitHub</a></p>
            <p> <a href='https://www.instagram.com/facundo_betancur97/'  target='_blank'  rel='noreferrer'>Instagram</a></p>
              
        </div>
      </div>
      
      <p> © 2023 - Todos los derechos reservados a <b> Signore </b></p>
      
    
    </footer>
  )
}
